import { RequireConsultation } from './RequireConsultation';
export default RequireConsultation;
